import { getLocaleVideoAdMappingFromSlug } from 'interfaces/videoAdCategoryMapping'
import { useRouter } from 'next/router'

export type Props = {
  categorySlug?: string
}

const OutstreamVideoAd = ({ categorySlug }: Props) => {
  const { locale = 'vi-VN' } = useRouter()
  if (!categorySlug) return null
  const channelId = getLocaleVideoAdMappingFromSlug(
    locale,
    decodeURI(categorySlug),
  )
  if (!channelId) return null
  return (
    <script
      src="//cdn.spotxcdn.com/website/integration_test/media/asia/spotx_sticky_skip.js"
      data-desktop-channel_id={channelId}
      data-desktop-width="300"
      data-desktop-height="169"
      data-mobile-channel_id={channelId}
      data-mobile-width="220"
      data-mobile-height="129"
      data-close-delay="15"
    />
  )
}

export { OutstreamVideoAd }
